<div class="cov-user-preferences d-flex flex-column gap-2">
  <div class="cov-user-info d-flex gap-2 mb-2">
    <div class="cov-profile">
      <div class="cov-user">
        <cov-icon [iconName]="IconName.USER" class="cov-user-icon"></cov-icon>
      </div>
    </div>

    <div class="d-flex flex-column gap-1">
      @if (currentUser()) {
        <span class="cov-greeting">
          {{ 'preferences.greeting' | transloco: { firstName: currentUser()?.firstName } }}
        </span>
        <span class="cov-user-email">{{ currentUser()?.uid }}</span>
      } @else if (asmUser()) {
        <span class="cov-greeting">
          {{ 'preferences.greeting' | transloco: { firstName: asmUser()?.agent?.firstName } }}
        </span>
        <span class="cov-user-email">{{ asmUser()?.agent?.displayUid }}</span>
      }
    </div>
  </div>

  <hr />

  @if (
    sessionStates()?.includes(SESSIONS.IMPERSONATESESSION) || sessionStates()?.includes(SESSIONS.CURRENTUSER)
  ) {
    <div mat-menu-item>
      <a routerlinkactive="active-link" class="cov-nav-link" (click)="goToContacts()">
        {{ 'preferences.navigation.contacts' | transloco }}
      </a>
    </div>
    <div mat-menu-item>
      <a routerlinkactive="active-link" class="cov-nav-link" (click)="goToPreferences()">
        {{ 'preferences.navigation.preferences' | transloco }}
      </a>
    </div>
    <div mat-menu-item>
      <a routerlinkactive="active-link" class="cov-nav-link" (click)="goToNotificationSettings()">
        {{ 'preferences.navigation.notificationSettings' | transloco }}
      </a>
    </div>
    <hr />
  }
  @if (currentUser() || asmUser()) {
    <div mat-menu-item>
      <mat-form-field>
        <select
          matNativeControl
          name="lang"
          [ngModel]="language()"
          (ngModelChange)="changeLang($event)"
        >
          @for (lang of supportedLanguages; track lang) {
            <option [value]="lang">
              {{ lang | toNativeLanguageName }}
            </option>
          }
        </select>
      </mat-form-field>
    </div>
    <hr />
  }

  @if (!sessionStates()?.includes(SESSIONS.IMPERSONATESESSION)) {
    <div mat-menu-item>
      <a
        routerlinkactive="active-link"
        class="cov-nav-link d-flex justify-content-between"
        (click)="logout()"
      >
        {{ 'preferences.navigation.logout' | transloco }}
        <cov-icon [iconName]="IconName.LOGOUT" class="ms-1"></cov-icon>
      </a>
    </div>
  }
</div>
